var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1753",
    viewBox: "0 0 9.9178247 9.9178247",
    height: "9.9178247mm",
    width: "9.9178247mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(318.67915,9.5839146)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,0.35277777,-507.74784,-215.28968)",
    id: "g394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path396",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 536.44275,592.72394 v -9.12097 h 9.12097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 554.4353,583.60297 h 9.12097 v 9.12097"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,0.35277777,-318.50273,-9.4075518)",
    id: "g400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path402",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 9.1209888,9.1209888"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,0.35277777,-312.15532,-9.4075518)",
    id: "g404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path406",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 9.1209888,0 0,9.1209888"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,0.35277777,-507.74784,-215.28968)",
    id: "g408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path410",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 545.56372,610.71649 h -9.12097 v -9.12103"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 563.55627,601.59546 v 9.12103 h -9.12097"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,0.35277777,-318.50273,-3.0601711)",
    id: "g414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path416",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,9.1209888 9.1209888,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,0.35277777,-312.15532,-3.0601711)",
    id: "g418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path420",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 9.1209888,9.1209888 0,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.4d3c38649d0ed6c7fbad4e781b1fe620.svg";
export { ForwardRef as ReactComponent };